import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type FAQItem = {
  id: string;
  questionKey: string;
  answerKey: string;
};

type Props = {
  items: FAQItem[];
};

function FAQ({ items }: Props) {
  const { t } = useTranslation();
  const [openItems, setOpenItems] = useState<Set<string>>(new Set());

  const toggleItem = (id: string) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(id)) {
      newOpenItems.delete(id);
    } else {
      newOpenItems.add(id);
    }
    setOpenItems(newOpenItems);
  };

  return (
    <div className="space-y-4">
      {items.map((item) => {
        const isOpen = openItems.has(item.id);
        
        return (
          <div key={item.id} className="border border-gray-200 rounded-lg overflow-hidden">
            <button
              onClick={() => toggleItem(item.id)}
              className="w-full px-6 py-4 text-left bg-card hover:bg-muted transition-colors flex justify-between items-center"
            >
              <h3 className="text-lg font-semibold text-foreground pr-4">
                {t(item.questionKey)}
              </h3>
              <svg
                className={`w-5 h-5 text-muted-foreground transition-transform duration-200 ${
                  isOpen ? 'rotate-180' : ''
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            
            {isOpen && (
              <div className="px-6 pb-4 bg-muted">
                <p className="text-foreground leading-relaxed">
                  {t(item.answerKey)}
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default FAQ; 